import { render, staticRenderFns } from "./dr-data-widget.vue?vue&type=template&id=f772218e"
import script from "./dr-data-widget.vue?vue&type=script&lang=js"
export * from "./dr-data-widget.vue?vue&type=script&lang=js"
import style0 from "./dr-data-widget.vue?vue&type=style&index=0&id=f772218e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports